import { ReactComponent as SearchIcon } from "../../../assets/icons/Magnifer.svg";
import { ReactComponent as UploadIcon } from "../../../assets/icons/Upload.svg";
import { ReactComponent as SearchImage } from "../../../assets/icons/search-companies.svg";
import { ReactComponent as UploadImage } from "../../../assets/icons/upload-companies.svg";
import { ReactComponent as Download } from "../../../assets/icons/Download.svg";
import { useNavigate } from "react-router-dom";
import FileUploadPupUp from "../../common/FileUploadPupUp";
import { useState } from "react";
import { useSelector } from "react-redux";
import { convertText, onDownloadDocument } from "../../../utils/Helper";
import { CommonToast } from "../../common/Toast";
import { uploadFileToS3 } from "../../../utils/uploadFileToS3";
import { uploadFilePath } from "../../../constants/s3UploadPath";
import { useUploadEnterpriseLinkMutation } from "../../../store/Company/companyApiSlice";

const AddCompaniesSection = ({ enterprise }) => {
    const navigate = useNavigate();

    const [isShowPopup, setIsShowPopup] = useState(false);
    const [clear, setClear] = useState(false);
    const [clickedRow, setClickedRow] = useState(null);
    const [previewImage, setPreviewImage] = useState("");
    const [fileUploading, setFileUploading] = useState(false);
    const { token, userInfo } = useSelector((state) => state.auth);
    const [isOpen, setIsOpen] = useState(false);
    const [progress, setProgress] = useState(0);
    const [uploadedFile, setUploadedFile] = useState("");
    const [uploadEnterpriseLink] = useUploadEnterpriseLinkMutation();
    
    const modalHeaderHandle = async () => {
        try {
            setFileUploading(true)
            const uploadedUrl = await uploadFileToS3(
                uploadFilePath.enterprise,
                uploadedFile,
                token,
                enterprise?.company,
                "enterprise_batch",
            );
            if (uploadedUrl?.url) {
                const data = {
                    file_url: uploadedUrl?.url,
                    enterprise_solution_id: enterprise.id
                }
                const response = await uploadEnterpriseLink({
                    data: data,
                    token: token,
                });
                if (response.data) {
                    CommonToast.success(response?.data?.message || "File uploaded successfully. Admin has been notified for manual processing.")
                } else {
                    CommonToast.error("Something went wrong")
                }
            }
            setUploadedFile("")
        } catch (error) {
            setUploadedFile("")
            CommonToast.error("Something went wrong");
        } finally {
            setFileUploading(false);
            setIsShowPopup(false);
        }
    };


    const renderPreview = () => {
        if (uploadedFile.type.includes("image")) {
            return <img src={previewImage} alt="trade" className="w-18" />;
        } else if (
            uploadedFile.type === "application/pdf" ||
            uploadedFile.type === "text/csv"
        ) {
            return (
                <embed
                    src={`${URL.createObjectURL(uploadedFile)}#page=1`}
                    type={uploadedFile.type}
                    width="100%"
                    height="500px"
                />
            );
        } else {
            return <p>Unsupported file type</p>;
        }
    };

    const handleModalClose = () => {
        setIsShowPopup(false);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
    };

    const handleFileSelect = async (file) => {
        setUploadedFile(file);
        setProgress(100);
        if (file && file.type.match("image.*")) {
            const reader = new FileReader();

            reader.onload = (e) => {
                setPreviewImage(e.target.result);
            };

            reader.readAsDataURL(file);
        } else {
            setPreviewImage(null);
        }
    };
    const fileTitle = clickedRow?.registered_company_name ? convertText(clickedRow?.registered_company_name) + "_ent_soln_template" : ""

    return (
        <>
            <div className="w-full bg-white border border-[#EAECF0] rounded-[16px] p-4 sm:p-6 text-left">
                {/* Title */}
                <h2 className="text-lg font-semibold text-[#101828] mb-4">
                    Start Adding Businesses to Track & Manage
                </h2>

                {/* Cards */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                    {/* SEARCH CARD */}
                    <div className="border border-[#EAECF0] rounded-[16px] p-4 flex flex-col gap-4">
                        {/* Image Placeholder */}
                        {/* <div className="h-[160px] bg-[#F2F4F7] rounded-lg flex items-center justify-center"> */}
                        {/* Replace with actual image if needed */}
                        <SearchImage className="w-full h-auto" />
                        {/* <span className="text-sm text-gray-400">TREXEV Illustration</span> */}
                        {/* </div> */}

                        <div className="flex flex-col gap-2">
                            <h3 className="text-[20px] font-semibold text-[#181D27]">
                                Search Businesses in TREVEX Database
                            </h3>
                            <p className="text-[16px] text-[#686C73]">
                                Quickly find existing businesses from the TREVEX database and add
                                them to your dashboard instantly.
                            </p>
                        </div>

                        <button onClick={() => navigate("/")} className="text-[18px] mt-auto w-full flex items-center justify-center gap-2 border border-[#FF3B30] text-[#FF3B30] rounded-[4px] py-3 font-medium hover:bg-red-50 transition">
                            <SearchIcon />
                            Search Business
                        </button>
                    </div>

                    {/* UPLOAD CARD */}
                    <div className="border border-[#EAECF0] rounded-xl p-4 flex flex-col gap-4">
                        {/* Image Placeholder */}
                        {/* <div className="h-[160px] bg-[#F2F4F7] rounded-lg flex items-center justify-center"> */}
                        {/* Replace with actual image if needed */}
                        <UploadImage className="w-full" />
                        {/* <span className="text-sm text-gray-400">CSV Upload Illustration</span> */}
                        {/* </div> */}

                        <div className="flex flex-col gap-2">
                            <div className="flex items-center justify-between">
                                <h3 className="text-[20px] font-semibold text-[#181D27]">
                                    Upload Businesses via CSV
                                </h3>

                                <button onClick={() => onDownloadDocument(process.env.REACT_APP_SAMPLE_ENTERPRISE_FILE, null, null, "Sample_file")} className="text-[14px] text-[#2B6483] font-medium flex items-center gap-1">
                                    <Download />CSV File Format
                                </button>
                            </div>

                            <p className="text-[16px] text-[#686C73]">
                                Upload a CSV file to add multiple businesses at once and start
                                tracking them efficiently.
                            </p>
                        </div>

                        <button onClick={() => setIsShowPopup(true)} className="text-[18px] mt-auto w-full flex items-center justify-center gap-2 border border-[#FF3B30] text-[#FF3B30] rounded-[4px] py-3 font-medium hover:bg-red-50 transition">
                            <UploadIcon />
                            Upload CSV File
                        </button>
                    </div>
                </div>
            </div>
            {isShowPopup && (
                <FileUploadPupUp handleModalClose={handleModalClose}
                    handleSubmit={handleSubmit}
                    renderPreview={renderPreview}
                    uploadedFile={uploadedFile}
                    handleFileSelect={handleFileSelect}
                    progress={progress}
                    setClear={setClear}
                    clear={clear}
                    setUploadedFile={setUploadedFile}
                    setPreviewImage={setPreviewImage}
                    modalHeaderHandle={modalHeaderHandle}
                    setProgress={setProgress}
                    fileUploading={fileUploading}
                    fileTitle={fileTitle}
                    customTitle="Add Businesses"
                    subText="Choose how you prefer to add your buyers"
                />
            )}
        </>
    );
};

export default AddCompaniesSection;
